import React, { PureComponent } from 'react';

class RenglonDatosAdicionales extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            centroCosto,
            claseUltimoRegistro,
            criterios,
            estaDesplegado,
            nroRenglon,
            signo,
            tipoApertura,
            tipoRenglon
        } = this.props;

        //Array para agrupar los pares clave:valor que se posicionan a la derecha del contenedor de datos adicionales
        let arrayCriterios = [];

        if (tipoRenglon === "Automático") {
          arrayCriterios.push(
            <div key={"signo-" + nroRenglon.toString()} className="AsientosContables--overflowHidden">
              <div className="AsientosContables--floatLeft seccionRenglonesModelo__renglonModelo__datoAdicionalTitulo__criteriosContables">{"Signo:"}</div>
              <div className="AsientosContables--floatLeft seccionRenglonesModelo__renglonModelo__datoAdicionalValor">{signo}</div>
            </div>
          );
        }
        
        let criteriosFiltrados = criterios.filter(cf => cf.DeleteInstance === false || cf.DeleteInstance === undefined);
        let criteriosReducidos = criteriosFiltrados.reduce((r, a) => {
          r[a.DescripcionCriterio] = [...r[a.DescripcionCriterio] || [], a];
          return r;
        }, {});
        
        if (tipoRenglon === "Automático") {
          for (let keyNombre in criteriosReducidos) {
            arrayCriterios.push(
              <div key={nroRenglon.toString() + "_" + keyNombre.replace(" ", "_")} className="AsientosContables--overflowHidden--flex">
                <div className="AsientosContables--floatLeft seccionRenglonesModelo__renglonModelo__datoAdicionalTitulo__criteriosContables">
                  {keyNombre + ":"}
                </div>
                <span className="AsientosContables--floatLeft seccionRenglonesModelo__renglonModelo__datoAdicionalValor">
                  {criteriosReducidos[keyNombre].map(c => c.DescripcionValorCriterio === null ? "Todos" : c.ValorCriterio + " - " + c.DescripcionValorCriterio).join(", ")}
                </span>
              </div>
            );
          }
        }
        
        
        return (
              <div className={`seccionRenglonesModelo__renglonModelo__contenedorDatosAdicionales slider-tarjetas seccionRenglonesModelo__renglonModelo__contenedorDatosAdicionales--desplegado ${claseUltimoRegistro && estaDesplegado ? "ultimo-desplegado" : claseUltimoRegistro ? "ultimo-no-desplegado" : ""} ${estaDesplegado ? "" : "closed"}`}>

                <div className="seccionRenglonesModelo__renglonModelo__datoAdicionalIzquierda">
                        <div className="AsientosContables--overflowHidden seccionRenglonesModelo__renglonModelo__datoAdicionalContenedorTituloValor">
                            <div className="AsientosContables--floatLeft seccionRenglonesModelo__renglonModelo__datoAdicionalTitulo">{"Tipo renglón:"}</div>
                            <div className="AsientosContables--floatLeft seccionRenglonesModelo__renglonModelo__datoAdicionalValor">{tipoRenglon}</div>
                        </div>

                        <div className="AsientosContables--overflowHidden seccionRenglonesModelo__renglonModelo__datoAdicionalContenedorTituloValor">
                            <div className="AsientosContables--floatLeft seccionRenglonesModelo__renglonModelo__datoAdicionalTitulo">{"Apertura:"}</div>
                            <div className="AsientosContables--floatLeft seccionRenglonesModelo__renglonModelo__datoAdicionalValor">{tipoApertura}</div>
                        </div>

                        <div className="AsientosContables--overflowHidden seccionRenglonesModelo__renglonModelo__datoAdicionalContenedorTituloValor">
                            <div className="AsientosContables--floatLeft seccionRenglonesModelo__renglonModelo__datoAdicionalTitulo">{"Centro de costo:"}</div>
                            <div className="AsientosContables--floatLeft seccionRenglonesModelo__renglonModelo__datoAdicionalValor">{centroCosto}</div>
                        </div>
                    </div>
                <div>
                  <div className="seccionRenglonesModelo__lineaDivisoriaHorizontal"></div>
                </div>
                <div>
                {tipoRenglon === "Automático" ? (
                <div className="seccionRenglonesModelo__renglonModelo__datoAdicionalDerecha">
                    <div> 
                    {tipoRenglon === "Automático" ? (
                            <div className="AsientosContables--overflowHidden seccionRenglonesModelo__renglonModelo__datoAdicionalContenedorTituloValor">
                                <div className="AsientosContables--floatLeft seccionRenglonesModelo__renglonModelo__datoAdicionalTitulo">{"Criterios contables"}</div>
                            </div>
                        ) : null}
                        <div className='ABMModelos__scrollCriteriosContables'>
                            {arrayCriterios}
                        </div>
                    </div>
                </div>
                ) :
                 <div className='seccionRenglonesModelo__labelSinCriteriosContables'>Sin criterios contables</div>}
                </div>
            </div>
        );
    }
}

export default RenglonDatosAdicionales;